export default __webpack_public_path__ + "static/media/remove.fb2b121d.svg";